import React from 'react';
import { Button, Grid } from '@material-ui/core';
import './Satellite.css';
import { withStyles } from '@material-ui/core/styles';
import { COMMON_IMG, EVENT_FOLDER, EVENT_IMG } from '../constants';

const styles = (theme) => ({
  box: {
    [theme.breakpoints.down('sm')]: {
      '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
        height: '100%',
      },
    },
  },
  companyLogo: {
    width: '90%',

    [theme.breakpoints.down('sm')]: {
      width: '40%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
  imgWrap: {
    flexDirection: 'column',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      flexDirection: 'row',
    },
  },
});

class SatelliteItem extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  render() {
    const { classes, changeIndex, satelliteIndex, isKcta } = this.props;

    return this.state.matches ? (
      // 모바일
      <div className={classes.box} style={{ outline: '1px solid #dedee6', padding: '20px 10px', marginTop: '1px' }}>
        <Grid container spacing={1} justifyContent="center" alignItems="center">
          <Grid item xs={7} container justifyContent="center" alignItems="center" className={classes.imgWrap}>
            {isKcta ? (
              <img src={`${EVENT_IMG}/kcta_image.JPG`} alt={'kcta_image'} className={classes.companyLogo} style={{ width: '100%' }} />
            ) : (
              <img
                src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.satellite.logo}.png`}
                alt={'logo'}
                className={classes.companyLogo}
              />
            )}
            {isKcta ? (
              ''
            ) : (
              <>
                <br />
                <b>{this.props.satellite.name}</b>
              </>
            )}
          </Grid>
          <Grid item xs={5} container direction="column" className="selectarea">
            <Button
              className="btn_video"
              style={{ fontSize: '12px', color: '#fff', backgroundColor: this.props.theme.palette.primary.main, marginBottom: '10px' }}
              onClick={(e, type) => changeIndex('video', satelliteIndex)}
            >
              <img src={`${COMMON_IMG}/ic_video.png`} alt={'video'} />
              <span>&nbsp;Video</span>
            </Button>
            <Button
              className="btn_program"
              style={{ fontSize: '11px', color: '#555', backgroundColor: '#e3e6f2' }}
              onClick={(e, type) => changeIndex('program', satelliteIndex)}
            >
              <img src={`${COMMON_IMG}/ic_program.png`} alt={'video'} />
              <span>&nbsp;Program</span>
            </Button>
          </Grid>
        </Grid>
      </div>
    ) : (
      // 웹
      <div className="box">
        <Grid container justifyContent="center" alignItems="center" className="imgWrap" style={{ height: isKcta ? 'auto' : '140px' }}>
          {isKcta ? (
            <img src={`${EVENT_IMG}/kcta_image.JPG`} alt={'kcta_image'} className={classes.companyLogo} style={{ width: '100%' }} />
          ) : (
            <img
              src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.props.satellite.logo}.png`}
              alt={'logo'}
              className={classes.companyLogo}
            />
          )}
        </Grid>

        <Grid container justifyContent="space-between" className="selectarea">
          <Button
            className="btn_video"
            style={{ fontSize: '12px', color: '#fff', backgroundColor: this.props.theme.palette.primary.main }}
            onClick={(e, type) => changeIndex('video', satelliteIndex)}
          >
            <img src={`${COMMON_IMG}/ic_video.png`} alt={'video'} />
            <span>&nbsp;Video</span>
          </Button>
          &nbsp;&nbsp;
          <Button
            className="btn_program"
            style={{ fontSize: '12px', color: '#555', backgroundColor: '#eee' }}
            onClick={(e, type) => changeIndex('program', satelliteIndex)}
          >
            <img src={`${COMMON_IMG}/ic_program.png`} alt={'video'} />
            <span>&nbsp;Program</span>
          </Button>
        </Grid>
        <span className="label">{!isKcta && this.props.satellite.name}</span>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SatelliteItem);
